module.exports = __webpack_public_path__ + "static/img_1986-686e6f353ded06d95208b50fe76843b4.webp";